import { Body, Card, Group, H6, Label, Stack } from '@qred/components-library';
import React from 'react';
import { useSelector } from 'react-redux';
import { useCurrencyFormatter } from '~/hooks/formatter/useCurrencyFormatter';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store';

export const LastBasicStepSummaryBox = () => {
  const t = useTranslate();
  const formatter = useCurrencyFormatter();
  const { amount, companyName } = useSelector(
    (state: RootState) => state.loanApplication.form
  );

  return (
    <Card
      p={12}
      color="Container/Option_1_(Greige_I)"
      mt={'auto'}
      px="md"
      py="sm"
    >
      <Group justify={'space-between'} nowrap>
        <Stack spacing="sm">
          <Label size="lg" color="Text/Headlines_(Brand)">
            {companyName}
          </Label>
          <Stack spacing="xs">
            <Body size="sm" color="Text/Secondary">
              {t('Onboarding.BasicApplicationFinalStepLoanAmount')}
            </Body>
            <H6 color="Text/Headlines_(Brand)">
              {formatter.format(Number(amount.replaceAll(/\D/g, '')))}
            </H6>
          </Stack>
        </Stack>
        <img
          src="/Confirmation.svg"
          alt="Confirmation"
          style={{ width: '80px', height: '80px' }}
        />
      </Group>
    </Card>
  );
};
